import { createContext, useState } from "react";

export const Message = createContext();

export const MassageProvider = ({ children }) => {
    const [formMessage, setFormMessage] = useState(null);
    return <Message.Provider value={[formMessage, setFormMessage]}>{children}</Message.Provider>;
};
